import { useBlueberrySizeData } from './useBlueberrySizeData';

export const useBlueberrySizeTableData = useBlueberrySizeData;
